/* global PipeSDK, chrome */

const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Assessment Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {assessments} assessments the resource defined to manage assessments
 */
app.directive('videoQuestionPresenter', ['Application', 'Authorization', 'AssessmentLib', 'S3Uploads', 'Upload', '$q', '$translate', function(Application, Authorization, AssessmentLib, S3Uploads, Upload, $q, $translate) {
    return {
      restrict: 'E',
      scope: {
        question: '=',
        userResponses: '=',
        onResponse: '&',
        description: '=?'
      },
      template: require('../../../templates/directives/assessments/video-question-presenter.html'),
      controller: ['$scope', '$window', function($scope, $window) {
          var self = this;
          self.pipe_recorder = null;
          self.is_ready_to_record = false;
          self.is_recording = false;
          self.navigationPath = {};
          self.showDeparture = false;
          self.submitting = false;
          self.is_mobile = Application.device.isMobile();
          self.browser_name = Application.device.browser.name;
          self.hasExtension = true;
          self.description = $scope.description;
          self.keep_active_interval_id = null;
          self.translations = {};
          self.hideUpload = false;
          self.lightboxStatus = false;
          self.lightboxUrl = '';

          self.triggerRecord = function() {
            self.pipe_recorder.record();
          };

          self.carousel = {
            total: 0,
            pages: 1,
            position: 1,
            viewableWidth: 0,
            available: {
              prev: false,
              next: false
            },
            calculateTotal: function(attempts) {
              self.carousel.total = attempts.length;
            },
            calculatePages: function(total) {
              self.carousel.pages = Math.ceil(total.length / 4);
            },
            prev: function() {
              if (self.info.thumbnailLoading) {
                return;
              }
              self.carousel.changePosition('prev');
              self.carousel.setAvailable();
            },
            next: function() {
              if (self.info.thumbnailLoading) {
                return;
              }
              self.carousel.changePosition('next');
              self.carousel.setAvailable();
            },
            changePosition: function(direction) {
              if (self.carousel.pages > 1) {
                if (direction === 'prev') {
                  if (self.carousel.position > 1) {
                    self.carousel.position--;
                    self.carousel.calculateViewableWidth();
                    self.carousel.setOffset(self.carousel.position)
                  }
                }
                if (direction === 'next') {
                  if (self.carousel.position < self.carousel.pages) {
                    self.carousel.position++;
                    self.carousel.calculateViewableWidth();
                    self.carousel.setOffset(self.carousel.position)
                  }
                }
              }
            },
            calculateViewableWidth: function() {
              var vidlist = $window.document.querySelector('.vidlist__main');
              self.carousel.viewableWidth = vidlist.clientWidth;
            },
            setOffset: function(page) {
              var vidlist = $window.document.querySelector('.vidlist__list');
              vidlist.setAttribute('page', page);
              if (page !== 1) {
                vidlist.style.left = '-' + (self.carousel.viewableWidth * (page - 1)) + 'px';
              } else if (page === 1) {
                vidlist.style.left = '0px';
              }
            },
            setAvailable: function() {
              self.carousel.available.prev = (self.carousel.pages > 1 && self.carousel.position !== 1);
              self.carousel.available.next = (self.carousel.pages > 1 && self.carousel.position < self.carousel.pages)
            },
            init: function() {
              self.carousel.calculatePages(self.info.previous_links);
              self.carousel.calculateTotal(self.info.previous_links);
              self.carousel.setAvailable();
            }
          };

          self.initialize_pipe = function() {
            var c = document.createElement('link');
            c.rel = 'stylesheet';
            c.href = 'https://cdn.addpipe.com/2.0/pipe.css';
            document.body.appendChild(c);

            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = 'https://cdn.addpipe.com/2.0/pipe.js';
            s.async = false;
            s.onload = () => { self._initialize_pipe(''); };
            document.body.appendChild(s);
          }

          self._initialize_pipe = function() {
            var recording_limit = 60 * (self.info.settings.recording_limit || 1);
            var pipeParams = {size: {width: 640, height: 390}, qualityurl: 'avq/720p.xml', accountHash: '8d4c7c11c5145404e2e33679193ee1b1', eid: 1, showMenu: 1, mrt: recording_limit, sis: 0, asv: 1, mv: 0, dpv: 0, ao: 0, dup: 0};

            if (self.info.settings.recording_type === 'screen_voice') {
              pipeParams.srec = 'hheibolndbaldmebflahggppgpbcofdc';
            }
            var language_file = 'https://' + window.location.host + '/static/en.xml';
            pipeParams.lang = language_file;
            if (self.info.settings.recording_type === 'screen_voice') {
              if (self.browser_name !== 'Chrome') {
                self.hasExtension = false;
                $scope.$apply();
                return;
              }
              if (!chrome.runtime) {
                self.hasExtension = false;
                $scope.$apply();
                return;
              }
              chrome.runtime.sendMessage('hheibolndbaldmebflahggppgpbcofdc', {message: "version"}, function(reply) {
                if (reply && reply.version) {
                  self.hasExtension = (reply.version >= 1.2);
                } else {
                  self.hasExtension = false;
                }
                $scope.$apply();
              });
            }

            PipeSDK.insert('continu-video-recorder', pipeParams, function(recorder_object) {

              if (self.info.settings.recording_type === 'screen_voice') {
                self.removeStartRecordingButton();
              }
              self.keep_active_interval_id = setInterval(function() {
                Authorization.setActive();
              }, 10 * 60 * 1000);

              self.pipe_recorder = recorder_object;
              self.pipe_recorder.onRecordingStarted = function(id) {
                if (self.info.settings.recording_limit) {
                  self.info.timer.reset();
                }
                self.is_recording = true;
                $scope.$apply();
              };
              self.pipe_recorder.btRecordPressed = function(id) {
                /**
                 * Place any Count Down Here
                 */
                self.is_recording = true;
              };
              self.pipe_recorder.onReadyToRecord = function(recorderId, recorderType) {
                if (self.info.settings.recording_type === 'screen_voice') {
                  self.pipe_recorder.record();
                }
                self.hideUpload = true;
                self.is_ready_to_record = true;
                $scope.$apply();
              };

              self.pipe_recorder.btStopRecordingPressed = function(recorderId) {
                self.is_recording = false;
              };

              self.pipe_recorder.onUploadDone = function(recorderId, streamName, streamDuration, audioCodec, videoCodec, fileType, audioOnly, location) {
                var link = 'https://' + location + '/8d4c7c11c5145404e2e33679193ee1b1/' + streamName + '.mp4';
                self.info.save(link);
              };

              self.pipe_recorder.onUploadDone = function(recorderId, streamName, streamDuration, audioCodec, videoCodec, fileType, audioOnly, location) {
                var link = 'https://' + location + '/8d4c7c11c5145404e2e33679193ee1b1/' + streamName + '.mp4';
                self.info.save(link);
              };
              if (self.is_mobile) {
                self.pipe_recorder.onVideoUploadStarted = function(recorderId, filename, filetype, audioOnly) {
                  self.is_ready_to_record = true;
                  self.is_recording = true;
                };
                self.pipe_recorder.onVideoUploadSuccess = function(recorderId, filename, filetype, videoId, audioOnly, location) {
                  var link = 'https://' + location + '/8d4c7c11c5145404e2e33679193ee1b1/' + filename + '.' + filetype;
                  self.info.save(link);
                };
                self.pipe_recorder.onVideoUploadFailed = function(recorderId, error) {
                  console.log('Error occured uploading video.', error);
                };
              }
            });

          };
          $window.onbeforeunload = function() {
            if (!self.submitting && self.is_ready_to_record) {
              return self.translations['vidQuestionPres.leave_confirm'];
            } else {
              clearInterval(self.keep_active_interval_id);
              self.removeRecordingPlugin();
            }
          };
          $scope.$parent.$on('$locationChangeStart', function(event) {
            if (!self.submitting && self.is_ready_to_record) {
              if (!confirm(self.translations['vidQuestionPres.leave_confirm'])) {
                event.preventDefault();
              } else {
                clearInterval(self.keep_active_interval_id);
                self.removeRecordingPlugin();
              }
            } else {
              clearInterval(self.keep_active_interval_id);
              self.removeRecordingPlugin();
            }

          });
          self.removeRecordingPlugin = function() {
            if (self.pipe_recorder) {
              self.pipe_recorder.remove();
            }
          };
          self.submitCurrentAttempt = function() {
            self.submitting = true;
            clearInterval(self.keep_active_interval_id);
            self.removeRecordingPlugin();
            if (self.info.selected_link) {
              var add = $scope.userResponses[$scope.question.id].splice(self.info.selected_link, 1)[0];
              $scope.userResponses[$scope.question.id].unshift(add);
            }
            $scope.onResponse({submit: true});
          };
          self.removeStartRecordingButton = function() {
            var start_record_button = document.getElementById('pipeStartRecording-continu-video-recorder');
            if (start_record_button.parentNode) {
              start_record_button.parentNode.removeChild(start_record_button);
            }
          };
          self.removeRecordingButton = function() {
            var record_button = document.getElementById('pipeRec-continu-video-recorder');
            record_button.parentNode.removeChild(record_button);
          };

          self.generateThumbnail = function(prom, link, delay) {
            var deferred = prom ? prom : $q.defer();

            if (self.info.thumbnailDirectory[link]) {
              deferred.resolve(self.info.thumbnailDirectory[link]);
              return deferred.promise;
            }

            var video = document.createElement('video');
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d')

            video.addEventListener('loadeddata', function() {
              context.drawImage(video, 0, 0, canvas.width, canvas.height);
              video.pause();

              var dataURI = canvas.toDataURL('image/jpeg');
              self.info.thumbnailDirectory[link] = dataURI;

              deferred.resolve(dataURI);
            }, false);

            video.addEventListener('error', function(error) {
              setTimeout(function() {
                self.generateThumbnail(deferred, link, delay);
              }, 3500)
            }, false);

            video.preload = 'metadata';
            video.muted = true;
            video.playsInline = true;
            video.setAttribute('crossOrigin', 'anonymous');
            video.src = link;
            video.play();

            if (!prom) {
              return deferred.promise;
            }
          };

          self.upload = {
            file: null,
            loadingBar: false,
            loadingPercent: 0,
            progress: {},
            uploaderId: 'video-attempt-upload',
            begin: function() {
              self.upload.file = null;
              self.upload.loadingPercent = 0;
              self.upload.progress = {};
              document.getElementById(self.upload.uploaderId).click();
            },
            onVideoSelect: function(file) {
              if (file.size > 1024000000) {
                Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.1024_limit'], duration: 5});
                return;
              }

              self.upload.filename = file.name;

              S3Uploads.videoPolicy({fileName: file.name, contentType: file.type}, function(data) {
                var cloudFrontLink = data.CloudFrontLink;
                var s3ObjectKey = data.Key;
                var FileName = data.FileName;
                Upload.upload({
                  url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
                  headers: {'Remove-auth': 'yes'},
                  method: 'POST',
                  data: {
                    key: data.Key,
                    'Content-Type': data.ContentType,
                    AWSAccessKeyId: data.AWSAccessKeyId,
                    'success_action_status': '201',
                    policy: data.S3Policy,
                    signature: data.S3Signature
                  },
                  file: file
                }).progress(function(evt) {
                  var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
                  self.upload.loadingBar = true;
                  self.upload.loadingPercent = percent;
                  self.upload.progress = {'width': parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10) + '%'};
                }).success(function(data) {
                  self.upload.loadingBar = false;
                  self.upload.loadingPercent = 0;
                  self.upload.progress = {};
                  self.info.save(cloudFrontLink);
                }).catch(function(error) {
                  Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.contents_error'], duration: 5});
                });
              }, function(error) {
                Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
              });
            }
          };

          $scope.$watch('videoPresenter.upload.file', function(newVal, oldVal) {
            if (newVal && !newVal.$error) {
              self.upload.onVideoSelect(self.upload.file);
            }
          });

          self.info = {
            thumbnailDirectory: {},
            settings: {},
            timer: {
              minutes: 0,
              seconds: 0,
              limit: 0,
              reset: function() {
                clearInterval(self.info.interval_id);
                self.info.timer.minutes = 0;
                self.info.timer.seconds = 0;
                self.info.interval_id = null;
              },
              init: function() {
                if (self.info.settings.timer_limit) {
                  self.info.timer.limit = new Date(new Date().getTime() + (self.info.settings.timer_limit * 60000)).getTime();
                }
                if (self.info.interval_id !== null) {
                  self.info.timer.reset();
                }
                self.info.interval_id = setInterval(function() {
                  var now = new Date().getTime();
                  var distance = self.info.timer.limit - now;
                  self.info.timer.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                  self.info.timer.seconds = Math.floor((distance % (1000 * 60)) / 1000);
                  $scope.$apply();
                  if (distance < 0) {
                    self.info.timer.reset();
                    var link = 'none_timeout';
                    if (self.is_recording) {
                      self.pipe_recorder.stopVideo();
                      self.pipe_recorder.save();
                      var streamName = self.pipe_recorder.getStreamName();
                      link = 'https://' + Application.RECORDING_DISTRIBUTION + '.cloudfront.net/' + streamName + '.mp4';
                    }
                    self.info.save(link);
                  }
                }, 1000);
              }
            },
            available_attempts: 0,
            previous_attempts: 0,
            current_attempt: 1,
            previous_links: [],
            selected_link: 0,
            show_link: false,
            viewing: 0,
            view_link: function(index) {
              if (self.info.previous_links.length <= index) {
                return;
              }
              self.info.viewing = index;
              self.info.show_link = true;
            },
            interval_id: null,
            choose_link: function(index) {
              if (self.info.thumbnailLoading) {
                return;
              }
              if (self.info.previous_links && self.info.previous_links.length > index) {
                self.info.selected_link = index;
              }
              self.info.view_link(index);
            },
            calculate_attempts: function(choose_first) {
              var thumbnailPromises = [];
              if ($scope.userResponses[$scope.question.id]) {
                self.info.previous_attempts = $scope.userResponses[$scope.question.id].length;
                self.info.current_attempt = self.info.previous_attempts + 1;
                self.info.previous_links = $scope.userResponses[$scope.question.id];
                if (self.info.settings.choose_attempt && self.info.previous_links.length > 0) {
                  self.info.thumbnailLoading = true;
                  self.info.previous_links.forEach(function(link) {
                    thumbnailPromises.push(self.generateThumbnail(null, link, choose_first));
                  });
                  if (choose_first && !self.info.show_when_available) {
                    self.info.choose_link(0);
                  }
                }
              }
              if (self.info.settings.max_attempts) {
                self.info.available_attempts = self.info.settings.max_attempts - self.info.previous_attempts;
              } else {
                self.info.available_attempts = 1 - self.info.previous_attempts;
              }
              if (thumbnailPromises.length) {
                $q.all(thumbnailPromises)
                    .then(function(results) {
                      self.info.thumbnailLoading = false;
                      if (self.info.show_when_available) {
                        self.info.show_when_available = false;
                        if (choose_first) {
                          self.info.choose_link(0);
                        }
                      }
                    })
              }
            },
            parse: function() {
              self.info.settings = AssessmentLib.helpers.getQuestionOptions($scope.question);
              self.info.calculate_attempts();
              if (self.info.available_attempts > 0) {
                self.initialize_pipe();
                return
              }
              self.info.show_link = true;
            },
            save: function(link) {
              clearInterval(self.info.interval_id);
              clearInterval(self.keep_active_interval_id);
              if ($scope.userResponses[$scope.question.id]) {
                $scope.userResponses[$scope.question.id].unshift(link);
              } else {
                $scope.userResponses[$scope.question.id] = [link];
              }

              $scope.onResponse();

              self.info.show_when_available = true;
              self.info.calculate_attempts(true);
            }
          };

          self.info.parse();
          self.carousel.init();

          $translate([
            'vidQuestionPres.leave_confirm',
            'edit.videos.1024_limit'
          ]).then(function(translations) {
            self.translations = translations;
          });

        }],
      controllerAs: 'videoPresenter'
    };
  }]);
